export const RootProductsPageEvents = {
    Selected: 'RootProductsPageEvents_Selected',
    ConfigurableProductSelected: 'RootProductsPageEvents_ConfigurableProductSelected'
};

